import assignSequence from "../helpers/assignSequence";
import calcAllRanks from "../helpers/calcAllRanks";
import sortMultiFields from "../helpers/sortMultiFields";

//-------------------------
// refresh combatant order
//-------------------------
export default function refreshCombatantOrder(combatants) {
  // console.log("------------------------")
  // console.log("IN refreshCombatantOrder")
  //----------------
  // calc all ranks
  //----------------
  combatants.forEach(calcAllRanks);
  //------------------------------------------
  // sort combatants (rank/dex/roll-off/name)
  //------------------------------------------
  combatants.sort(sortMultiFields(["-rank", "-dex", "-roll_off", "name"]));
  //--------------------
  // assign seq numbers
  //--------------------
  combatants.forEach(assignSequence);
  //--------
  // return
  //--------
  return combatants;
}
